import { PlainButton } from '@findy-code/yuffie/ui/button';
import type { ComponentProps } from 'react';
import { forwardRef } from 'react';

import styles from './close-button.module.scss';

export const CloseButton = forwardRef<
  HTMLButtonElement,
  ComponentProps<typeof PlainButton>
>((props, ref) => {
  const { className, children, ...rest } = props;
  return (
    <PlainButton
      className={[className, styles.closeButton].filter(Boolean).join(' ')}
      ref={ref}
      {...rest}
    >
      {children}
    </PlainButton>
  );
});

CloseButton.displayName = 'CloseButton';
